import React, { useEffect, useState } from "react";
import firebase from "../firebase/firebaseconfig";
import { useNavigate, useLocation } from "react-router-dom";
import OutsideClickHandler from "react-outside-click-handler";

function Navbar() {
  const [userId, setUserId] = useState("");
  const [userName, setUserName] = useState("");
  const [planType, setPlanType] = useState("");
  const [userRole, setUserRole] = useState("");
  const [subscriptionStatus, setSubscriptionStatus] = useState("");
  const [menuOpened, setMenuOpened] = useState(false);

  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid);
        setUserName(user.displayName);

        const userRef = firebase.database().ref("users/" + user.uid);
        userRef.on("value", (snapshot) => {
          const userVal = snapshot.val();
          if (userVal) {
            const status = userVal.subscriptionStatus ?? "";
            setSubscriptionStatus(status);
            setUserRole(userVal.role || "");
          }
        });
      } else {
        setUserId("");
        setUserName("");
        setSubscriptionStatus("");
      }
    });
  }, [userId]);

  const navigate = useNavigate();
  const location = useLocation();

  const isLoginPage = location.pathname === "/login" || location.pathname === "/success";

  const toggleMenu = () => {
    setMenuOpened(!menuOpened);
  };

  const closeMenu = () => {
    setMenuOpened(false);
  };

  return (
    <section className="bg-black">
      <div className="relative w-full flex flex-col justify-center items-center h-100 max-w-[130rem] mx-auto">
        <nav
          className={`navbar ${
            isLoginPage ? "justify-center" : "justify-between"
          } flex border-b-[0.5px] w-full border-gray-800 items-center px-4 sm:px-8 md:px-20 py-4 sm:py-6 bg-black text-white Gilroy-Medium`}
        >
          <div
            className={`navbar ${
              isLoginPage ? "pr-0" : "pr-16"
            } Gilroy-Bold text-2xl cursor-pointer z-10`}
            onClick={() => navigate("/")}
          >
            <span>
              Quick<span className="text-indigo-600">Tube</span>
            </span>
          </div>

          {!isLoginPage && (
            <>
              <div className="block lg:hidden z-10">
                <button
                  className="text-white focus:outline-none"
                  onClick={toggleMenu}
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    {menuOpened ? (
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    ) : (
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 6h16M4 12h16m-7 6h7"
                      />
                    )}
                  </svg>
                </button>
              </div>

              <div className="hidden lg:flex lg:flex-row lg:items-center lg:gap-x-5">
                <ul className="flex flex-col lg:flex-row z-10 lg:items-center lg:gap-x-5">
                  <li className="sm:mr-6">
                    <a className="nav-link" href="#product">
                      Product
                    </a>
                  </li>
                  <li className="sm:mr-6">
                    <a className="nav-link" href="/contact">
                      Contact
                    </a>
                  </li>
                  <li className="sm:mr-6">
                    <a className="nav-link" href="/pricing">
                      Pricing
                    </a>
                  </li>
                  <li>
                    <a className="nav-link" href="#whatsnew">
                      What's New
                    </a>
                  </li>
                </ul>
              </div>

              {!userId ? (
                <div className="hidden lg:flex navbar-right items-center justify-end z-10">
                  <button
                    className="mr-2 sm:mr-5 text-white nav-link"
                    onClick={() => navigate("/login")}
                  >
                    Login
                  </button>
                  <button
                    className="started bg-indigo-600 hover:bg-indigo-700 text-white h-8 sm:h-10 w-20 sm:w-24 md:w-28 rounded-[10px] ml-2 sm:ml-3 Gilroy-Medium transition duration-300 ease-in-out"
                    onClick={() => navigate("/login")}
                  >
                    Get Started
                  </button>
                </div>
              ) : subscriptionStatus === "active" ? (
                <div className="hidden lg:flex navbar-right items-center justify-end z-10">
                  <button
                    className=" bg-indigo-600 hover:bg-indigo-700 text-white h-8 sm:h-10 w-28 sm:w-32 md:w-36 rounded-[10px] ml-2 sm:ml-3 Gilroy-Medium transition duration-300 ease-in-out"
                    onClick={() =>
                      navigate(userRole === "youtuber" ? "/youtuber" : "/editor")
                    }
                  >
                    Workspace
                  </button>
                  <button
                    className="nav-link text-white ml-3 sm:ml-5"
                    onClick={() => firebase.auth().signOut()}
                  >
                    Logout
                  </button>
                </div>
              ) : (
                <div className="hidden lg:flex navbar-right items-center justify-end z-10">
                  <button
                    className="mr-2 sm:mr-5 text-white nav-link"
                    onClick={() => navigate("/pricing")}
                  >
                    Upgrade
                  </button>
                  <button
                    className="started bg-indigo-600 hover:bg-indigo-700 text-white h-8 sm:h-10 w-20 sm:w-24 md:w-28 rounded-[10px] ml-2 sm:ml-3 Gilroy-Medium transition duration-300 ease-in-out"
                    onClick={() => firebase.auth().signOut()}
                  >
                    Logout
                  </button>
                </div>
              )}
            </>
          )}
        </nav>
        {menuOpened && (
          <OutsideClickHandler onOutsideClick={closeMenu}>
            <div className="absolute top-[5rem] left-[10rem] right-0 bg-gray-900 w-[13rem] rounded-2xl text-white p-6 shadow-lg z-20 Gilroy-Medium lg:hidden">
              <ul className="flex flex-col text-center gap-y-5">
                <li>
                  <a className="nav-link" href="#product" onClick={closeMenu}>
                    Product
                  </a>
                </li>
                <li>
                  <a className="nav-link" href="/contact" onClick={closeMenu}>
                    Contact
                  </a>
                </li>
                <li>
                  <a className="nav-link" href="/pricing" onClick={closeMenu}>
                    Pricing
                  </a>
                </li>
                <li>
                  <a className="nav-link" href="#whatsnew" onClick={closeMenu}>
                    What's New
                  </a>
                </li>
                {!userId ? (
                  <>
                    <li>
                      <button
                        className="nav-link text-white"
                        onClick={() => {
                          navigate("/login");
                          closeMenu();
                        }}
                      >
                        Login
                      </button>
                    </li>
                    <li>
                      <button
                        className="started bg-indigo-600 hover:bg-indigo-700 text-white h-8 sm:h-10 w-full rounded-[10px] Gilroy-Medium transition duration-300 ease-in-out"
                        onClick={() => {
                          navigate("/login");
                          closeMenu();
                        }}
                      >
                        Get Started
                      </button>
                    </li>
                  </>
                ) : subscriptionStatus === "active" ? (
                  <>
                    <li>
                      <button
                        className=" bg-indigo-600 hover:bg-indigo-700 text-white h-8 sm:h-10 w-full rounded-[10px] Gilroy-Medium transition duration-300 ease-in-out"
                        onClick={() => {
                          navigate(userRole === "youtuber" ? "/youtuber" : "/editor");
                          closeMenu();
                        }}
                      >
                        Workspace
                      </button>
                    </li>
                    <li>
                      <button
                        className="nav-link text-white"
                        onClick={() => {
                          firebase.auth().signOut();
                          closeMenu();
                        }}
                      >
                        Logout
                      </button>
                    </li>
                  </>
                ) : (
                  <>
                    <li>
                      <button
                        className="nav-link text-white"
                        onClick={() => {
                          navigate("/pricing");
                          closeMenu();
                        }}
                      >
                        Upgrade
                      </button>
                    </li>
                    <li>
                      <button
                        className="started bg-indigo-600 hover:bg-indigo-700 text-white h-8 sm:h-10 w-full rounded-[10px] Gilroy-Medium transition duration-300 ease-in-out"
                        onClick={() => {
                          firebase.auth().signOut();
                          closeMenu();
                        }}
                      >
                        Logout
                      </button>
                    </li>
                  </>
                )}
              </ul>
            </div>
          </OutsideClickHandler>
        )}
      </div>
    </section>
  );
}

export default Navbar;
